
import { React, useEffect, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

export default ({ show, onHide, onSearch }) => {
  const [
    message,
    setMessage,
  ] = useState('');

  const inputRef = useRef(null);

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch(message);
      setMessage('');
    }
  };

  useEffect(() => {
    if (show) {
      inputRef.current.focus();
    }
  }, [show]);

  return (
    <Modal style={{ backgroundColor: 'rgb(0, 0, 0, 0.4)', paddingTop: '20vh' }} contentClassName="whiteContentModal" show={show} onHide={onHide}>
      <input ref={inputRef} type="text" placeholder="Search" style={{ color: 'black', height: '60px', borderRadius: '10px', padding: '0 10px' }} onChange={handleChange} onKeyDown={handleKeyDown} />
    </Modal>

  );
};
